<template>
  <div>
    <div class="preferenceHeader my-5">
      <TopDeck firstElement="Informations personnelles" />
      <v-btn
        color="accent"
        class="white-text-button"
        rounded="xl"
        size="small"
        @click="router.push('/edit_preferences')"
      >
      <v-icon icon="mdi-pencil" class="mr-2"></v-icon>
        Modifier
      </v-btn>
    </div>

    <div class="profileContainer">
      <!-- Colonne 1 -->
      <div class="profileColumn">
        <div class="profileBloc">
          <h3  class="underline">Informations personnelles</h3>
          <p><strong>Email :</strong> {{ safeUser.email }}</p>
          <p><strong>Âge :</strong> {{ safeUser.age }}</p>
          <p><strong>Sexe :</strong> {{ safeUser.sex ? $t(safeUser.sex) : '' }}</p>
          <p><strong>Taille :</strong> {{ safeUser.actualSize }} cm</p>
          <p><strong>Poids actuel :</strong> {{ safeUser.actualWeight }} kg</p>
        </div>

        <div class="profileBloc">
          <h3 class="underline">Mode de vie</h3>
          <p><strong>Métier :</strong> {{ safeUser.job ? $t(safeUser.job) : '' }}</p>
          <p><strong>Niveau d'activité :</strong> {{ safeUser.activityLevel ? $t(safeUser.activityLevel) : '' }}</p>
          <p><strong>Nombre de pas quotidiens :</strong> {{ safeUser.dailySteps }}</p>
          <p><strong>Séances de sport par semaine :</strong> {{ safeUser.weeklyWorkouts }}</p>
          <p>
            <strong>Repas pris :</strong>
            {{ safeUser.takenMeals.length ? safeUser.takenMeals.map(m => $t(m)).join(', ') : 'Aucun' }}
          </p>
          <p>
            <strong>Magasins préférés :</strong>
            {{ safeUser.preferedGroceryStore.length ? safeUser.preferedGroceryStore.map(s => $t(s)).join(', ') : 'Aucun' }}
          </p>
        </div>
      </div>

      <!-- Colonne 2 -->
      <div class="profileColumn">

        <div class="profileBloc">
          <h3 class="underline">Objectifs</h3>
          <p><strong>Objectif de poids :</strong> {{ safeUser.targetWeight }} kg</p>
          <p><strong>Objectif principal :</strong> {{ safeUser.weightObjective ? $t(safeUser.weightObjective) : '' }}</p>
          <p>
            <strong>Objectif secondaire :</strong>
            {{ safeUser.secondaryObjective.length ? safeUser.secondaryObjective.map(o => $t(o)).join(', ') : 'Aucun' }}
          </p>
          <p>
            <strong>Repas ciblés :</strong>
            {{ safeUser.takenMealsObjectives.length ? safeUser.takenMealsObjectives.map(o => $t(o)).join(', ') : 'Aucun' }}
          </p>
        </div>

        <div class="profileBloc">
          <h3  class="underline">Préférences alimentaires</h3>
          <p>
            <strong>Allergies :</strong>
            {{ safeUser.allergies.length ? safeUser.allergies.map(i => $t(i)).join(', ') : 'Aucune' }}
          </p>
          <p>
            <strong>Intolérances :</strong>
            {{ safeUser.intolerances.length ? safeUser.intolerances.map(i => $t(i)).join(', ') : 'Aucune' }}
          </p>
          <p><strong>Régime :</strong> {{ safeUser.diet.length ? safeUser.diet.map(d => $t(d)).join(', ') : 'Aucun' }}</p>
          <p><strong>Viande :</strong> {{ safeUser.meatConsumption ? $t(safeUser.meatConsumption) : '' }}</p>
          <p><strong>Alcool :</strong> {{ safeUser.alcoholConsumption ? $t(safeUser.alcoholConsumption) : '' }}</p>
          <p>
            <strong>Ingrédients à éviter :</strong>
            {{ safeUser.ingredientsToAvoid.length ? safeUser.ingredientsToAvoid.map(i => $t(i)).join(', ') : 'Aucun' }}
          </p>
          <p>
            <strong>Ingrédients à inclure :</strong>
            {{ safeUser.ingredientsToInclude.length ? safeUser.ingredientsToInclude.map(i => $t(i)).join(', ') : 'Aucun' }}
          </p>
          <p>
            <strong>Conditions médicales :</strong>
            {{ safeUser.medicalConditions.length ? safeUser.medicalConditions.map(c => $t(c)).join(', ') : 'Aucune' }}
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { defineProps, computed } from 'vue';
import TopDeck from '../Utils/TopDeck.vue';

const router = useRouter();

const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
});

const toArray = (value) => (Array.isArray(value) ? value : []);

const safeUser = computed(() => {
  const u = props.user || {};
  return {
    ...u,
    takenMeals: toArray(u.takenMeals),
    preferedGroceryStore: toArray(u.preferedGroceryStore),
    secondaryObjective: toArray(u.secondaryObjective),
    takenMealsObjectives: toArray(u.takenMealsObjectives),
    allergies: toArray(u.allergies),
    intolerances: toArray(u.intolerances),
    diet: toArray(u.diet),
    ingredientsToAvoid: toArray(u.ingredientsToAvoid),
    ingredientsToInclude: toArray(u.ingredientsToInclude),
    medicalConditions: toArray(u.medicalConditions),
  };
});
</script>

<style scoped>
.preferenceHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 0.6rem 0.2rem;
  border-bottom: 1px solid rgba(var(--v-theme-text), 0.08);
}

.profileContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.profileColumn {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.profileBloc {
  position: relative;
  background: linear-gradient(
    155deg,
    rgba(var(--v-theme-secondary), 0.96),
    rgba(var(--v-theme-tertiary), 0.88)
  );
  padding: 1.6rem 1.7rem;
  border-radius: 18px;
  line-height: 1.65;
  border: 1px solid rgba(var(--v-theme-text), 0.08);
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.underline {
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  margin-bottom: 0.8rem;
  position: relative;
  padding-bottom: 0.4rem;
}

.underline::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 56px;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-accent), 0.95),
    rgba(var(--v-theme-accent), 0.55)
  );
}

.profileBloc::before {
  content: "";
  position: absolute;
  top: -30%;
  right: -15%;
  width: 180px;
  height: 180px;
  background: radial-gradient(
    circle,
    rgba(var(--v-theme-accent), 0.18),
    rgba(0, 0, 0, 0) 70%
  );
  pointer-events: none;
}

.profileBloc p {
  margin: 0.35rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.6rem;
  align-items: baseline;
  color: rgba(var(--v-theme-text), 0.85);
}

.profileBloc p strong {
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(var(--v-theme-text), 0.6);
  font-weight: 700;
}

@media (min-width: 900px) {
  .profileContainer {
    align-items: stretch;
  }
}
</style>
